export default __webpack_public_path__ + "static/media/green_tick_mark.846f91f4.svg";